export class EvaluationFoodsModel{
    id?: number;
    foodId?: number;
    userId?: number;
    numberOfStars?: number;
    comment?:string;
    date?:Date;
    time?:Date;
    isHide?:boolean;

    


    constructor(item?:EvaluationFoodsModel){
        item = item? item:{};
        this.id = item.id? item.id:0;
        this.foodId = item.foodId? item.foodId:0;
        this.userId = item.userId? item.userId:0;
        this.numberOfStars = item.numberOfStars? item.numberOfStars:0;
        this.comment = item.comment? item.comment:'';
        this.date = item.date? item.date:new Date();
        this.time = item.time? item.time:new Date();
        this.isHide = item.isHide? item.isHide:false;
      
        
    
    }

}